import useSWR from 'swr';

import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';

interface IUseServiceSyncExceptionParams {
  startDate: string;
  endDate: string;
  serviceId: string;
}

const useServiceSyncException = ({
  startDate,
  endDate,
  serviceId,
}: IUseServiceSyncExceptionParams) => {
  const query = new URLSearchParams({
    startDate,
    endDate,
    isSyncedException: `${true}`,
  }).toString();

  const clinicId = loadSelectedClinicId();
  const url = `/services/${serviceId}/check-synced-exceptions?${query}`;

  const { data, error, mutate } = useSWR<string[]>(
    [url, clinicId],
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useServiceSyncException;
